import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyBK2bmxep7UQHpBEsQnfuYXgNYHjf3edeA',
  authDomain: 'iaya-ac586.firebaseapp.com',
  databaseURL: 'https://iaya-ac586.firebaseio.com',
  projectId: 'iaya-ac586',
  storageBucket: 'iaya-ac586.appspot.com',
  messagingSenderId: '994763964140',
  appId: '1:994763964140:web:6f1f7983950127ea',
};

firebase.initializeApp(config);
// var db = firebase.firestore();
// db.collection('meetups')
//   .doc()
//   .set({ name: 'john' })
//   .then(function() {
//     console.log('Document successfully created!');
//   });
//   .set({
//     next_title: 'pwa dev summit 2019',
//     next_desc:
//       'Meet awesome web developers and designers for a two-day developer summit.',
//     next_rsvp_url:
//       'https://pwafire.org/developer/codelabs/cloud-firestore-for-web/',
//     recent_title: 'pwa dev summit 2019',
//     recent_desc:
//       'Meet awesome web developers and designers for a two-day developer summit.',
//     recent_rsvp_url:
//       'https://pwafire.org/developer/codelabs/cloud-firestore-for-web/',
//   })

//   .then(function() {
//     console.log('Document successfully created!');
//   });

//const database = firebase.database();
// for (var i = 0; i < 10; i++) {
//     database.ref('Event').push({
//         name: 'Event',
//         title: 'Event',
//         text: 'Allah forgive me',
//         eventLink: ''
//     }).then(() => {
//         console.log('Data is saved!');
//     }).catch((e) => {
//         console.log('Failed.', e);
//     });
// }
export default firebase;
